import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
import Repository from '@/app/repositories/repository'

const categoryRepository = RepositoryFactory.get('category');

export default Object.assign(categoryRepository, {
    getMainCategories: function(){
        return Repository.get(`/category/getMainCategories`);
    },
    getTree: function(categoryId){
        return categoryId ? Repository.get(`/category/getTree?categoryId=${categoryId}`) : Repository.get(`/category/getTree`);
    },
    getBySlug: function(slug){
        return Repository.get(`${this.resource}/getBySlug?slug=${slug}`);
    },
});
